import {
    RESET_TOKEN
} from './actionTypes';

export function resetToken() {
    return {
        type: RESET_TOKEN
    }
}